import { Zap, ShieldCheck, Users, Heart } from "lucide-react";

const ITEMS = [
  { Icon: Zap, title: "Sürətli nəticə", text: "Layihələrinizi vaxtında təhvil veririk." },
  { Icon: ShieldCheck, title: "Təhlükəsiz yanaşma", text: "Məlumatlarınız hər zaman qorunur." },
  { Icon: Users, title: "Peşəkar komanda", text: "Təcrübəli mütəxəssislərlə işləyirik." },
  { Icon: Heart, title: "Dəyərli tərəfdaşlıq", text: "Sizin uğurunuz bizim üçün önəmlidir." },
];

export default function Advantages() {
  return (
    <section id="about" data-testid="advantages-section" className="scroll-mt-20">
      <div className="max-w-[1320px] mx-auto px-3 md:px-10">
        <div className="adv-panel rounded-[22px] text-[#F3EEE4] px-6 sm:px-12 py-10 md:py-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map(({ Icon, title, text }, i) => (
            <div key={title} className="relative" data-testid={`advantage-${i}`}>
              <Icon size={24} strokeWidth={1.5} className="text-[#D6AD62]" />
              <h3 className="font-display font-semibold text-[16px] mt-5">{title}</h3>
              <p className="text-[13px] text-[#a9a398] mt-2 leading-relaxed max-w-[200px]">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
